<template>
	<el-table
			v-if=" !loading && propsData && show && tabData.length > 0"
			height="100%"
			:data="tabData"
			style="width: 100%">
		<el-table-column
				key="-2"
				fixed
				prop="loopName"
				label="回路名称"
				width="220"
		>
		</el-table-column>
		<el-table-column
				key="-1"
				fixed
				prop="total"
				label="总用电量"
				width="200">
		</el-table-column>
		<el-table-column
				v-for="(item, index) in titles"
				:key="index"
				:prop="item"
				:label="item"
				width="108">
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {
		dayStart,
		dayEnd,
		monthStart,
		yearStart,
		monthEnd,
		yearEnd,
		monthDays,
		currentDay
	} from "../../../util/DateUtil";
	import {INFLUX_QUERY} from "../../../api/power"
	import exportExcel from "../../../util/excel";
	import {floatFormat} from "../../../util/MathUtil"

	export default {
		name: "PowerTime",
		props: {
			loops: Array,
			range: String,
			date: Date
		},
		data(){
			return {
				titles: [],
				loading: false,
				tabData: [],
				show: false,
			}
		},
		watch:{
			diagramStatus(n){
				if(this.$route.params.name === 'Extremum' && this.$route.params.tag === 'PowerTime' ){
					if(n.type === 'excel' && this.tabData.length > 0){

						let data = [
							['回路名称', '总用电量']
						]

						this.titles.forEach(t => {
							data[0].push(t)
						})

						this.tabData.forEach(d => {
							data.push([d.loopName, d.total, ...this.titles.map(t => d[t])])
						})
						exportExcel(data, '用电量时段报表', [])

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
			propsData(n){
				this.tabData = []
				this.generateTitle()
				this.requestData()
			},
		},
		computed:{
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			propsData(){
				return [
					this.date,
					this.range,
					this.loops
				]
			}
		},
		methods:{
			getLoopName(code){
				return this.loops.filter(loop => {
					//return loop.loopUrl === code
					return code.indexOf(loop.subLoopUrl) !== -1
				})[0].loopName
			},
			generateTitle(n){
				if(!n){
					n = this.range
				}
				switch (n) {
					case "day":
						this.titles = []
						for (let i = 0; i < 24; i++) {
							this.$set(this.titles, i, i < 10 ? '0' + i + ':00' : i + ':00')
						}
						break
					case "month":
						this.titles = []
						for (let i = 0; i < monthDays(this.date); i++) {
							this.$set(this.titles, i, i + 1 + '日')
						}
						break
					case "year":
						this.titles = []
						for (let i = 0; i < 12; i++) {
							this.$set(this.titles, i, i + 1 + '月')
						}
						break
				}

				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			},
			keyGenerate(time) {
				let date = new Date(time)
				switch (this.range) {
					case "day":
						let hours = date.getHours();
						return hours < 10 ? '0' + hours + ':00' : hours + ':00'
					case "month":
						return currentDay(date) + '日'
					case "year":
						return date.getMonth() + 1 + '月'
				}
			},
			async requestData(){

				if(this.loops.length <= 0){
					return
				}

				this.loading = true

				let ids = this.loops.map(l => l.loopId);
				let start
				let end
				let group

				switch (this.range) {
					case "day":
						start = dayStart(this.date)
						end = dayEnd(this.date)
						group = '1h'
						break
					case "month":
						start = monthStart(this.date)
						end = monthEnd(this.date)
						group = '1d'
						break
					case "year":
						start = yearStart(this.date)
						end = yearEnd(this.date)
						group = '1d'
						break

				}

				let res = await INFLUX_QUERY(ids, start, end, group,["PA_total"])

				let influxData = res.data.data.influxData

				console.log(influxData)

				let list = []

				try {
					
					influxData.results.forEach(result => {
						result.series.forEach(serie => {
							let obj = {}
							let sum = 0
							serie.values.forEach(val => {
								let k = this.keyGenerate(val[0])
								let v = Number(obj[k])
								
								if (v) {
									if (v === '--') {
										obj[k] = (val[4] !== null ? val[4] : '--')
									} else {
										obj[k] = floatFormat((val[4] !== null ? val[4] : 0) + v,2)
									}
								} else {
									obj[k] = val[4] !== null ? floatFormat(val[4],2) : '--'
								}
								obj.code = serie.tags.code
								sum += val[4] ? val[4] : 0
							})
							obj.total = floatFormat(sum,2) + ' kWh';
							obj.loopName = this.getLoopName(serie.tags.code)
							list.push(obj)
						})
					})
				} catch (e) {

				}
				console.log(list);

				list.sort((a, b) => {
					return b.total - a.total
				})
				this.tabData = list
				console.log(this.tabDate,"this.tabData")
				this.loading = false
			}
		},
		mounted() {
			this.generateTitle()
			this.requestData()
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>